var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"w-full"},[_c('div',{staticClass:"flex flex-col items-center justify-center w-full bg-white rounded-b-3xl gap-4 pt-1"},[_vm._t("default"),_c('span',{staticClass:"bg-crm-17 h-1 w-30 rounded-md bg-center mb-1"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }